import { Controller } from "stimulus"

export default class extends Controller {
  connect() {
    $("#update-demographics-modal").on("hidden.bs.modal", () => this.reset())
  }

  refreshSubmit() {
    this.submitButton().disabled = !this.file()
  }

  submit() {
    const file = this.file()
    if (!file) return

    document.getElementById('update-demographics-selection-step').classList.add('d-none')
    document.getElementById('update-demographics-progress-step').classList.remove('d-none')
    this.submitButton().classList.add('d-none')

    window.initiateDemographicsUpdateChannel(this.element.dataset.surveyId, this.element.dataset.uploadUrl, file)
  }

  reset() {
    this.fileInput().value = ''
    this.submitButton().disabled = true
    this.submitButton().classList.remove('d-none')
    document.getElementById('update-demographics-selection-step').classList.remove('d-none')
    document.getElementById('update-demographics-progress').style.width = '0%'
    document.getElementById('update-demographics-progress-text').textContent = '0%'
    'update-demographics-progress-step update-demographics-success update-demographics-errors update-demographics-error'.split(' ')
      .forEach((id) => document.getElementById(id).classList.add('d-none'))
  }

  file() { return this.fileInput().files[0] }
  fileInput() { return document.getElementById('update-demographics-file') }
  submitButton() { return document.getElementById('update-demographics-submit') }
}
